export const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
